"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureTwilioLogger = void 0;
const twilio_video_1 = require("twilio-video");
const sdk_lightshow_1 = require("@streem/sdk-lightshow");
const logger_1 = require("./logger");
function configureTwilioLogger(logger) {
    (0, logger_1.setLogger)(logger);
    (0, sdk_lightshow_1.configureLightshowLogger)(logger.extend('sdk-lightshow'));
    const twilioLogger = twilio_video_1.Logger.getLogger('twilio-video');
    const streemLogger = logger.extend('twilio-video');
    twilioLogger.methodFactory = function (methodName) {
        return function (...args) {
            // Clean up log messages by removing twilio timestamp and logLevel
            streemLogger[methodName](args.slice(2));
        };
    };
    twilioLogger.setLevel(getTwilioLogLevel());
}
exports.configureTwilioLogger = configureTwilioLogger;
function getTwilioLogLevel() {
    // we want more logging in non "production" even if running in production mode
    const debugEnvs = ['dev', 'development', 'local'];
    if (debugEnvs.indexOf(process.env.REACT_APP_ENV || '') !== -1) {
        if (process.env.LOG_VERBOSITY &&
            ['debug', 'info', 'warn', 'error', 'off'].includes(process.env.LOG_VERBOSITY)) {
            return process.env.LOG_VERBOSITY;
        }
        return 'info';
    }
    return 'error';
}
//# sourceMappingURL=configure_twilio_logger.js.map